module.exports = __webpack_public_path__ + "static/media/WE-Background.bfc226e5.jpg";